import { useCallback, useEffect, useState } from "react";
import { CustomButton } from "../../../../components/CustomButton";
import { ContainerHorario } from "../../styles";
import { FaEdit } from 'react-icons/fa';
import EditarCadastrarHorarioCupom from "./EditarCadastrar";
import * as S from '../../styles'
import { daysLabels } from '../../../../constants/daysLabels';
import api from "../../../../services/api";

const HorariosCupom = ({ cupom }) => {
    const [schedules, setSchedules] = useState([]);
    const [schedule, setSchedule] = useState();
    const [modalCreate, setModalCreate] = useState(false);

    const loadSchedules = useCallback(async () => {
        if (cupom.Id) {
            const { data } = await api.get(`horarios-cupom/listar/${cupom.Id}`);
            if (data?.length > 0) {
                setSchedules(data);
            }
        }
    }, []);

    useEffect(() => {
        loadSchedules();
    }, [])

    return (
        <>
            <ContainerHorario>
                <CustomButton
                    appearance="primary"
                    onClick={() => {
                        setSchedule(null);
                        setModalCreate(true)
                    }}>
                    Adicionar Horário
                </CustomButton>
                {schedules.map((item) => (
                    <S.Schedule key={item.Id}>
                        <S.ScheduleField>{daysLabels[item?.Dia]}</S.ScheduleField>
                        <S.ScheduleField>{item.Inicio}</S.ScheduleField>
                        <S.ScheduleField>{item.Fim}</S.ScheduleField>
                        <S.ScheduleStatus status={item.Ativo}>{item.Ativo ? 'Ativo' : 'Inativo'}</S.ScheduleStatus>
                        <S.ScheduleField>
                            <S.IconWrapper onClick={() => { setSchedule(item); setModalCreate(true) }}>
                                <FaEdit size={12} />
                            </S.IconWrapper>
                        </S.ScheduleField>
                    </S.Schedule>
                ))}
            </ContainerHorario>
            {modalCreate && <EditarCadastrarHorarioCupom
                open={modalCreate}
                handleClose={() => setModalCreate(false)}
                schedule={schedule}
                cupom={cupom}
                setSchedules={setSchedules}
            />}
        </>
    )
}

export default HorariosCupom;